import { render, staticRenderFns } from "./ProductsPromotionCreate.vue?vue&type=template&id=33c26604&"
import script from "./ProductsPromotionCreate.vue?vue&type=script&lang=js&"
export * from "./ProductsPromotionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports